var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnGoogleStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 62,
    viewBox: "0 0 168 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3533",
    "data-name": "\\uADF8\\uB8F9 3533",
    transform: "translate(-300 -7358.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_1801",
    "data-name": "\\uC0AC\\uAC01\\uD615 1801",
    transform: "translate(300 7358.738)",
    fill: "#fff",
    stroke: "#969696",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 62,
    rx: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 167,
    height: 61,
    rx: 30.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3286",
    "data-name": "\\uADF8\\uB8F9 3286",
    transform: "translate(328 7374.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1447",
    "data-name": "\\uD328\\uC2A4 1447",
    d: "M82.744,55.733a3.631,3.631,0,1,0,3.641,3.632,3.579,3.579,0,0,0-3.641-3.632m0,5.83a2.2,2.2,0,1,1,2.046-2.2A2.1,2.1,0,0,1,82.744,61.563ZM74.8,55.733a3.631,3.631,0,1,0,3.643,3.632A3.579,3.579,0,0,0,74.8,55.733Zm0,5.83a2.2,2.2,0,1,1,2.048-2.2A2.1,2.1,0,0,1,74.8,61.563Zm-9.459-4.716v1.54h3.687a3.218,3.218,0,0,1-.838,1.94,3.781,3.781,0,0,1-2.849,1.128,4.1,4.1,0,0,1,0-8.2,3.932,3.932,0,0,1,2.78,1.1L69.2,53.273a5.372,5.372,0,0,0-3.866-1.556,5.639,5.639,0,1,0,0,11.277,5.155,5.155,0,0,0,3.933-1.581,5.1,5.1,0,0,0,1.335-3.6,5.013,5.013,0,0,0-.083-.962Zm38.674,1.2a3.375,3.375,0,0,0-3.107-2.311,3.45,3.45,0,0,0-3.425,3.632,3.552,3.552,0,0,0,3.6,3.629,3.612,3.612,0,0,0,3.026-1.609l-1.238-.826a2.069,2.069,0,0,1-1.788,1,1.85,1.85,0,0,1-1.761-1.1l4.856-2.007Zm-4.95,1.211a1.991,1.991,0,0,1,1.9-2.117,1.4,1.4,0,0,1,1.346.769Zm-3.945,3.519H96.71V52.1H95.115ZM92.5,56.545h-.055a2.511,2.511,0,0,0-1.91-.812,3.634,3.634,0,0,0,0,7.261,2.463,2.463,0,0,0,1.91-.826H92.5v.522c0,1.39-.743,2.133-1.938,2.133a2.007,2.007,0,0,1-1.83-1.293l-1.388.578a3.456,3.456,0,0,0,3.217,2.145c1.871,0,3.45-1.1,3.45-3.781V55.954H92.5Zm-1.83,5.017a2.207,2.207,0,0,1,0-4.4,2.216,2.216,0,0,1,0,4.4ZM111.483,52.1h-3.816v10.67h1.59V58.732h2.226a3.319,3.319,0,1,0,0-6.628Zm.041,5.144h-2.267V53.588h2.267a1.83,1.83,0,1,1,0,3.659Zm9.843-1.533a3,3,0,0,0-2.842,1.632l1.413.591a1.5,1.5,0,0,1,1.455-.782,1.534,1.534,0,0,1,1.675,1.374v.108a3.512,3.512,0,0,0-1.662-.412c-1.524,0-3.072.838-3.072,2.4a2.463,2.463,0,0,0,2.649,2.347,2.246,2.246,0,0,0,2.03-1.043h.055v.822h1.537v-4.09A2.926,2.926,0,0,0,121.368,55.715Zm-.193,5.848c-.522,0-1.25-.262-1.25-.907,0-.824.907-1.139,1.687-1.139a2.85,2.85,0,0,1,1.457.357A1.932,1.932,0,0,1,121.174,61.563Zm9.033-5.616-1.825,4.626h-.058l-1.894-4.626h-1.717l2.845,6.465-1.623,3.6H127.6l4.38-10.062Zm-14.345,6.826h1.59V52.1h-1.59Z",
    transform: "translate(-19.302 -43.756)",
    fill: "#292a2a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3285",
    "data-name": "\\uADF8\\uB8F9 3285",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1448",
    "data-name": "\\uD328\\uC2A4 1448",
    d: "M60.929,58.2,44.071,48.467a1.558,1.558,0,0,0-1.65.058L56.515,62.617Z",
    transform: "translate(-41.682 -48.258)",
    fill: "#292a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1449",
    "data-name": "\\uD328\\uC2A4 1449",
    d: "M42.312,48.614a1.555,1.555,0,0,0-.212.769V76.667c0,.092.055.161.069.249L56.392,62.694Z",
    transform: "translate(-42.1 -47.795)",
    fill: "#292a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1450",
    "data-name": "\\uD328\\uC2A4 1450",
    d: "M42.276,69.394a1.554,1.554,0,0,0,1.984.384L61.539,59.8,56.7,54.966Z",
    transform: "translate(-41.871 -39.528)",
    fill: "#292a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1451",
    "data-name": "\\uD328\\uC2A4 1451",
    d: "M59.426,56.262,53.341,52.75l-4.562,4.561,4.98,4.98,5.666-3.27A1.594,1.594,0,0,0,59.426,56.262Z",
    transform: "translate(-33.407 -42.412)",
    fill: "#292a2a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnGoogleStore);
export default __webpack_public_path__ + "static/media/btn_google_store.0e8ae051.svg";
export { ForwardRef as ReactComponent };